export function normalizeProductCheckoutConfig(config) {
    if (!config) return config

    config.birth_date = config.birth_date ?? config.birth_date_enabled ?? false
    config.mobile_phone = config.mobile_phone ?? config.mobile_phone_enabled ?? false
    config.country_code = config.country_code ?? config.country_enabled ?? false
    config.document = config.document ?? config.document_enabled ?? false
    config.billing_address = config.billing_address ?? config.billing_address_enabled ?? false
    config.shipping_address = config.shipping_address ?? config.shipping_address_enabled ?? false

    if (!config.quantity_limit) {
        config.quantity_limit = { is_enabled: false }
    }

    return config
}
